import React from "react";
import * as C from "./styles";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useLocation, useNavigate } from "react-router-dom";
import {BsFillCalendarCheckFill} from "react-icons/bs"

type Props = {
  isOpened?: boolean;
  setSidebarOpened: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Sidebar({ isOpened, setSidebarOpened }: Props) {
  const navRef = React.useRef() as React.RefObject<HTMLDivElement>;

  const { user } = useSelector((store: RootState) => store.user);
  const location = useLocation()
    .pathname.split("/")
    .filter((path) => path)[1];

  const navigate = useNavigate();

  return (
    <>
      {isOpened && <C.Overlay />}
      <C.Container isOpened={isOpened ?? false}>
        <C.LogoContainer>
          <C.CloseMobile onClick={() => setSidebarOpened(!isOpened)} />
    <C.Logo/>
         
        </C.LogoContainer>
        <C.NavContainer ref={navRef}>
          {user?.TIPO == "1" && (
            <C.ItemContainer
              itemName="agendar"
              location={location}
              onClick={() => navigate(`/agendar`)}
            >
              <C.NavMark />
              <BsFillCalendarCheckFill />
              <C.ItemText>Agendar</C.ItemText>
            </C.ItemContainer>
          )}
        </C.NavContainer>
        <C.VersionLabel>V{process.env.REACT_APP_SYSTEM_VERSION}</C.VersionLabel>
      </C.Container>
    </>
  );
}
